import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'
import type { EnabledFilters } from 'components/Search/type'

const HOTEL_SEARCH_RESULTS_ROUTES = [
  '/:regionCode/search',
  '/:regionCode/search/map',
]

/** Hotel search list and map only — scopes filter-sections-v2 behaviour to its original experiment surface. */
export function isHotelSearchResultsPath(pathname: string): boolean {
  return !!matchLocaleAwarePath(pathname, { path: HOTEL_SEARCH_RESULTS_ROUTES, exact: true })
}

/**
 * Winning filter-sections-v2 treatment: facilities / room amenities / bed
 * type sections replace the single amenities filter, plus radio bedrooms.
 */
export function withHotelFilterSectionsV2EnabledFilters(enabledFilters: EnabledFilters): EnabledFilters {
  return {
    ...enabledFilters,
    amenities: false,
    propertyFacilities: true,
    roomAmenities: true,
    bedTypes: true,
    bedrooms: true,
    beds: false,
  }
}
